import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import ResourceLinks from './ResourceLinks';

const FeatureContent = ({
  upgradeConfig
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(UIMediaObject, {
    spacing: "extra-small",
    itemLeft: /*#__PURE__*/_jsx(UIIcon, {
      name: "upgrade",
      size: 20,
      color: LORAX
    }),
    className: "m-bottom-2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteInterstitialCard.upgrade"
    })
  }), /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H1, {
      className: "m-bottom-10",
      children: upgradeConfig.title
    }), /*#__PURE__*/_jsx("p", {
      className: "text-left",
      "data-test-id": "upgrade-modal-subtitle",
      dangerouslySetInnerHTML: {
        __html: upgradeConfig.subtitle
      }
    }), /*#__PURE__*/_jsx(ResourceLinks, {
      upgradeConfig: upgradeConfig
    })]
  })]
});

export default FeatureContent;